export const COURSES = "courses";
export const MANAGE_WEBSITES = "manage-websites";
export const IMAGE_THUMB_SIZE = 1000;

export const MAP_FEED_TYPES = {
  COURSE_MAP: "course-map",
  GRADE_MAP: "grade-map",
  DEPARTMENT_MAP: "department-map",
};

export const UNIT_VIEW_TYPES = {
  CARD: "card",
  TIMELINE: "timeline",
};

export const EMPTY_STATE_SUBTITLE_STYLE = { width: "436px" };
